import type { FooterNavProps } from '~/legacy/types';

const FooterNav = ({ menu }: FooterNavProps) => {
  return (
    <div
      className="global-footer__links flex--center flex--wrap"
      role="navigation"
    >
      {menu.map(({ link, name, external }) => {
        if (external) {
          return (
            <a
              href={link}
              className="btn btn--footer-overlay"
              key={name}
              rel="noopener noreferrer"
              target="_blank"
            >
              {name}
            </a>
          );
        }

        return (
          <a href={link} className="btn btn--footer-overlay" key={name}>
            {name}
          </a>
        );
      })}
    </div>
  );
};

export default FooterNav;
